export default __webpack_public_path__ + "f8ffc930af1356a9787b73e1fcb1cd83.png";